import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { fmtCurrency, fmtDate } from "@/lib/format";
import { Download } from "lucide-react";

export default function Invoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customer/invoices").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-8" data-testid="customer-invoices-page">
      <PageHeader eyebrow="Documents" title="Invoices" description="Downloadable invoice records imported from your developer's accounting system." />

      <DataTable
        testId="my-invoices-table"
        columns={[
          { key: "invoice_no", label: "Invoice #", render: (r) => <span className="font-mono font-bold">{r.invoice_no}</span> },
          { key: "amount", label: "Amount", render: (r) => <span className="font-mono">{fmtCurrency(r.amount)}</span> },
          { key: "issue_date", label: "Issued", render: (r) => fmtDate(r.issue_date) },
          { key: "description", label: "Description" },
          {
            key: "file_url",
            label: "File",
            render: (r) =>
              r.file_url ? (
                <a
                  href={r.file_url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`download-${r.id}`}
                  className="text-brand-600 hover:text-brand-700 text-xs uppercase tracking-wider font-bold flex items-center gap-1"
                >
                  <Download size={12} /> Download
                </a>
              ) : "—",
          },
        ]}
        rows={items}
        empty="No invoices yet."
      />
    </div>
  );
}
